import { required, shape, between, fromModel, when } from '@totalsoft/pure-validations';

export const expenseTypeValidator = fromModel(model =>
  shape({
    expenseCode: required,
    expenseName: required,
    vatId: required,
    currencyValue: between(model?.minValue, model?.maxValue) |> when(Boolean(model?.minValue) && Boolean(model?.maxValue)),
    currencyPercent: between(0, 100)
  })
);
